/* Portal configurations - global scope */

const helper = {};

// base config
helper.portal_name = 'SoundeesConcerts';
helper.portal_url = "soundees-concerts.com";
helper.type='concerts';

// api methods
helper.api_url = 'https://api.hubdelivery.io';
helper.api_methods = {
    'concerts': {
        'categories': '/content/concerts/categories',
        'concerts_by_category': '/content/concerts/concerts_by_category',
        'concert': '/content/concerts/concert',
        'concert_view': '/content/concerts/concert_view'
    },
    'legals': {
        'contact': '/content/legals/contact',
        'faq': '/content/legals/faq',
        'terms': '/content/legals/terms',
        'privacy': '/content/legals/privacy',
        'cookies_policy': '/content/legals/cookies_policy',
        'unsubscribe_text': '/content/legals/unsubscribe',
        'unsubscribe_phone': '/store/UnsubscribePhoneNumber'
    },
    'general': {
        'login': '/store/checkAccessCode',
        'login_phone': '/store/loginWithPhone',
        'check_phone_login': '/store/checkPhoneLoginAllowed'
    }
};

helper.country_phone_format = {
    'UK': '44xxxxxxxxx',
    'DE': '42xxxxxxxxx',
    'BG': '08xxxxxxxx',
    'RS': '06xxxxxxxx',
    'CZ': '7xxxxxxxx'
};

helper.country_default_language = {
    'UK': 'EN'
};

helper.country_register_landing = {
    'UK': 'https://uk.soundees-concerts.com/register',
    'BG': 'https://premium.soundees-concerts.com/bgSc77/',
    'DE': 'https://premium.soundees-concerts.com/deSc40/clk/',
    'RS': 'https://premium.soundees-concerts.com/rSsC09/'
};

export const helpers = helper;